/**
 * External dependencies
 */

/**
 * React dependencies
 */

import React, { useState, useEffect } from 'react';

/**
 * DWT components
 */

import Book from './Books/Book';
import Contributor from './Contributors/Contributor';
import Loader from './Loader';

/**
 * Book Component
 * Parent container for book list
 *
 * @param {Object}  props
 * @param {Array}   props.data
 * @param {Object}  props.context
 * @param {boolean} props.showMetadata
 * @param {boolean} props.error
 */
const Grid = React.memo( ({ data, context, showMetadata, error }) => {
  const [ delay, setDelay ] = useState( true );
  const blockClasses =
        context.featureBy === 'books'
          ? 'wp-block-dwt-book block__book'
          : 'wp-block-dwt-contributor block__contributor';

  useEffect( () => {
    const handleDelay = setTimeout( () => {
      setDelay( false );
    }, 2000 );

    return () => {
      clearInterval( handleDelay );
    };
  }, [] );

  return (
    !error &&
        data?.length > 0 &&
        data?.map( ( item, index ) => (
          <div
            className={blockClasses}
            data-list-index={index}
            key={self.crypto.randomUUID()}
          >
            {delay && <Loader showMetadata={showMetadata} />}

            {!delay && context.featureBy === 'books' && (
              <Book item={item} showMetadata={showMetadata} />
            )}

            {!delay && context.featureBy === 'contributors' && (
              <Contributor item={item} showMetadata={showMetadata} />
            )}
          </div>
        ) )
  );
});

export default Grid;
